import { updatesList } from '@/mocks/animeData';

const tagColorMap: Record<string, string> = {
  '最新': 'bg-accent-100 text-accent-700',
  '热门': 'bg-primary-100 text-primary-700',
  '推荐': 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            更新快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            实时追踪热门连载更新动态，追更党永不断档
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-[11px] md:left-[15px] top-2 bottom-2 w-0.5 bg-secondary-200"></div>

            <div className="flex flex-col gap-4">
              {updatesList.map((item, idx) => {
                const tagStyle = tagColorMap[item.tag] || 'bg-secondary-100 text-secondary-700';
                return (
                  <div key={idx} className="relative flex items-start gap-4 md:gap-5 group cursor-pointer">
                    <div className="absolute left-[-32px] md:left-[-40px] top-1.5 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full bg-primary-500 border-[3px] border-background-50 flex-shrink-0 group-hover:scale-125 transition-transform"></div>

                    <div className="flex-1 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 p-3 md:p-4 rounded-lg hover:bg-background-100 transition-colors">
                      <span className="text-xs text-foreground-400 font-mono whitespace-nowrap">
                        {item.time}
                      </span>
                      <span className="text-sm md:text-base text-foreground-800 font-medium flex-1">
                        {item.title}
                      </span>
                      <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${tagStyle} self-start sm:self-auto whitespace-nowrap`}>
                        {item.tag}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}